import Route from "./Route";
import { useNavigate } from "react-router-dom";
import { RiDashboard3Fill } from "react-icons/ri";
import useAuth from "../useAuth";
import logo from "../assets/logo.jpg";
import { IoPersonSharp } from "react-icons/io5";
import {
  FaUserPlus,
  FaBuilding,
  FaUsers,
  FaList,
  FaLaptop,
  FaFileAlt,
  FaNetworkWired,
  FaBroadcastTower,
  FaChartBar,
  FaIndustry,
  FaCogs,
  FaTachometerAlt,
  FaBoxOpen,
  FaClipboardList,
  FaWifi,
} from "react-icons/fa";

export default function NavBar() {
  const navigate = useNavigate();
  const { user, menuOpen, changeMenuSize } = useAuth();

  return (
    <div
      className={`relative bg-white w-full h-screen flex flex-col pt-4 border-r border-gray-200 transition-all duration-300 ${menuOpen ? "px-1" : "items-center"}`}
    >
      {/* Branding / Logo Section */}
      <div
        className={`flex items-center gap-3 px-3 mb-6 ${menuOpen ? "" : "justify-center"}`}
      >
        <div className="relative flex items-center justify-center">
          <img
            src={logo}
            className="w-10 h-10 object-contain rounded-full shadow-sm"
            alt="logo"
          />
        </div>
        {menuOpen && (
          <div className="flex flex-col overflow-hidden">
            <span className="text-sm font-bold text-gray-800 tracking-wide uppercase truncate">
              Bravishmah
            </span>
            <span className="text-[10px] text-gray-500 font-medium truncate">
              Admin Console
            </span>
          </div>
        )}
      </div>

      {/* Navigation Links */}
      <div className="flex-1 overflow-y-auto space-y-1 custom-scrollbar pb-4">
        {!user?.isReadOnly && (
          <Route
            name="Home"
            onClick={() => navigate("home")}
            icon={<RiDashboard3Fill />}
            urlPath="home"
            isCollapsed={!menuOpen}
          />
        )}

        {!user?.isReadOnly && (
          <div className={`my-2 px-4 ${!menuOpen && "hidden"}`}>
            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">
              Administration
            </p>
          </div>
        )}

        {!user?.isReadOnly && (
          <>
            <Route
              name="Users"
              onClick={() => navigate("users")}
              icon={<FaUsers />}
              urlPath="users"
              isCollapsed={!menuOpen}
            />
            <Route
              name="Register User"
              onClick={() => navigate("registerUser")}
              icon={<FaUserPlus />}
              urlPath="registerUser"
              isCollapsed={!menuOpen}
            />
            <Route
              name="WiFi Users"
              onClick={() => navigate("registered-wifi-users")}
              icon={<FaWifi />}
              urlPath="registered-wifi-users"
              isCollapsed={!menuOpen}
            />
            <Route
              name="Departments"
              onClick={() => navigate("departments")}
              icon={<FaList />}
              urlPath="departments"
              isCollapsed={!menuOpen}
            />
            <Route
              name="Add Department"
              onClick={() => navigate("addDepartment")}
              icon={<FaBuilding />}
              urlPath="addDepartment"
              isCollapsed={!menuOpen}
            />
          </>
        )}

        <div className={`my-2 px-4 ${!menuOpen && "hidden"}`}>
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">
            Inventory & Assets
          </p>
        </div>

        {!user?.isReadOnly && (
          <>
            <Route
              name="Stocks"
              onClick={() => navigate("stocks")}
              icon={<FaClipboardList />}
              urlPath="stocks"
              isCollapsed={!menuOpen}
            />
            <Route
              name="Add Stock"
              onClick={() => navigate("add-stock")}
              icon={<FaBoxOpen />}
              urlPath="add-stock"
              isCollapsed={!menuOpen}
            />
          </>
        )}
        <Route
          name="Devices"
          onClick={() => navigate("devices")}
          icon={<FaLaptop />}
          urlPath="devices"
          isCollapsed={!menuOpen}
        />

        <div className={`my-2 px-4 ${!menuOpen && "hidden"}`}>
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">
            Network Tools
          </p>
        </div>

        {!user?.isReadOnly && (
          <Route
            name="Network Scan"
            onClick={() => navigate("network-scan")}
            icon={<FaNetworkWired />}
            urlPath="network-scan"
            isCollapsed={!menuOpen}
          />
        )}
        {!user?.isReadOnly && (
          <Route
            name="Ping Device"
            onClick={() => navigate("ping-device")}
            icon={<FaBroadcastTower />}
            urlPath="ping-device"
            isCollapsed={!menuOpen}
          />
        )}
        <Route
          name="Device Logs"
          onClick={() => navigate("device-logs")}
          icon={<FaFileAlt />}
          urlPath="device-logs"
          isCollapsed={!menuOpen}
        />

        {!user?.isReadOnly && (
          <>
            <div className={`my-2 px-4 ${!menuOpen && "hidden"}`}>
              <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">
                Master Data
              </p>
            </div>

            <Route
              name="Manufacturers"
              onClick={() => navigate("manufacturers")}
              icon={<FaIndustry />}
              urlPath="manufacturers"
              isCollapsed={!menuOpen}
            />
            <Route
              name="Models"
              onClick={() => navigate("models")}
              icon={<FaCogs />}
              urlPath="models"
              isCollapsed={!menuOpen}
            />
            <Route
              name="Device Types"
              onClick={() => navigate("device-types")}
              icon={<FaTachometerAlt />}
              urlPath="device-types"
              isCollapsed={!menuOpen}
            />
          </>
        )}

        <>
          <div className={`my-2 px-4 ${!menuOpen && "hidden"}`}>
            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">
              Analytics
            </p>
          </div>

          <Route
            name="Reports"
            onClick={() => navigate("reports")}
            icon={<FaChartBar />}
            urlPath="reports"
            isCollapsed={!menuOpen}
          />
        </>

        <div
          className={`my-2 border-t border-gray-100 mx-4 ${!menuOpen && "hidden"}`}
        ></div>

        <Route
          name="Profile"
          onClick={() => navigate("profile")}
          urlPath="profile"
          icon={<IoPersonSharp />}
          isCollapsed={!menuOpen}
        />
      </div>
    </div>
  );
}
